// Generated by purs version 0.15.0
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_MultiSet from "../Data.MultiSet/index.js";
import * as Data_Set from "../Data.Set/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Restaumatic_Cart_ProductKey from "../Restaumatic.Cart.ProductKey/index.js";
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_Taxes from "../Restaumatic.Menu.V2.Types.Taxes/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var StandardPizza = /* #__PURE__ */ (function () {
    function StandardPizza(value0) {
        this.value0 = value0;
    };
    StandardPizza.create = function (value0) {
        return new StandardPizza(value0);
    };
    return StandardPizza;
})();
var CustomPizza = /* #__PURE__ */ (function () {
    function CustomPizza(value0) {
        this.value0 = value0;
    };
    CustomPizza.create = function (value0) {
        return new CustomPizza(value0);
    };
    return CustomPizza;
})();
var Pizza = /* #__PURE__ */ (function () {
    function Pizza(value0) {
        this.value0 = value0;
    };
    Pizza.create = function (value0) {
        return new Pizza(value0);
    };
    return Pizza;
})();
var Dish = /* #__PURE__ */ (function () {
    function Dish(value0) {
        this.value0 = value0;
    };
    Dish.create = function (value0) {
        return new Dish(value0);
    };
    return Dish;
})();
var Drink = /* #__PURE__ */ (function () {
    function Drink(value0) {
        this.value0 = value0;
    };
    Drink.create = function (value0) {
        return new Drink(value0);
    };
    return Drink;
})();
var SplitPizza = /* #__PURE__ */ (function () {
    function SplitPizza(value0) {
        this.value0 = value0;
    };
    SplitPizza.create = function (value0) {
        return new SplitPizza(value0);
    };
    return SplitPizza;
})();
var CustomProduct = /* #__PURE__ */ (function () {
    function CustomProduct(value0) {
        this.value0 = value0;
    };
    CustomProduct.create = function (value0) {
        return new CustomProduct(value0);
    };
    return CustomProduct;
})();
var MenuProduct = /* #__PURE__ */ (function () {
    function MenuProduct(value0) {
        this.value0 = value0;
    };
    MenuProduct.create = function (value0) {
        return new MenuProduct(value0);
    };
    return MenuProduct;
})();
var MenuCombo = /* #__PURE__ */ (function () {
    function MenuCombo(value0) {
        this.value0 = value0;
    };
    MenuCombo.create = function (value0) {
        return new MenuCombo(value0);
    };
    return MenuCombo;
})();
var toStoredPizzaDef = function (v) {
    if (v instanceof Restaumatic_Cart_ProductKey.StandardPizza) {
        return new StandardPizza(v.value0);
    };
    if (v instanceof Restaumatic_Cart_ProductKey.CustomPizza) {
        return new CustomPizza({
            basePizzaId: v.value0.basePizzaId,
            toppings: Data_MultiSet.elems(v.value0.toppings)
        });
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 155, column 3 - line 157, column 104): " + [ v.constructor.name ]);
};
var toStoredSplitPizzaKey = function (x) {
    return {
        parts: Data_Functor.map(Data_Functor.functorArray)(toStoredPizzaDef)(x.parts),
        size: x.size,
        panType: x.panType
    };
};
var toStoredProductKey = function (v) {
    if (v instanceof Restaumatic_Cart_ProductKey.Pizza) {
        return new Pizza({
            def: toStoredPizzaDef(v.value0.def),
            size: v.value0.size,
            panType: v.value0.panType
        });
    };
    if (v instanceof Restaumatic_Cart_ProductKey.Dish) {
        return new Dish({
            id: v.value0.id,
            sides: Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(v.value0.sides)
        });
    };
    if (v instanceof Restaumatic_Cart_ProductKey.Drink) {
        return new Drink(v.value0);
    };
    if (v instanceof Restaumatic_Cart_ProductKey.SplitPizza) {
        return new SplitPizza(toStoredSplitPizzaKey(v.value0));
    };
    if (v instanceof Restaumatic_Cart_ProductKey.CustomProduct) {
        return new CustomProduct(v.value0);
    };
    if (v instanceof Restaumatic_Cart_ProductKey.MenuProduct) {
        return new MenuProduct(v.value0);
    };
    if (v instanceof Restaumatic_Cart_ProductKey.MenuCombo) {
        return new MenuCombo(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 141, column 3 - line 148, column 38): " + [ v.constructor.name ]);
};
var modifyString = function (f) {
    return function (x) {
        var v = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)(x));
        if (v instanceof Data_Either.Left) {
            return x;
        };
        if (v instanceof Data_Either.Right) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(f(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 97, column 3 - line 99, column 28): " + [ v.constructor.name ]);
    };
};
var renameTags = function (f) {
    return function (x) {
        var v = Control_Monad_Except.runExcept(Foreign_Generic_Class.decode(Foreign_Generic_Class.objectDecode(Foreign_Generic_Class.foreignDecode))(x));
        if (v instanceof Data_Either.Left) {
            return x;
        };
        if (v instanceof Data_Either.Right) {
            return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.update((function () {
                var $99 = modifyString(f);
                return function ($100) {
                    return Data_Maybe.Just.create($99($100));
                };
            })())("tag")(v.value0));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 91, column 3 - line 93, column 74): " + [ v.constructor.name ]);
    };
};
var genericStoredProductKey = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Pizza(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Dish(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new Drink(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new SplitPizza(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new CustomProduct(x.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl))))) {
            return new MenuProduct(x.value0.value0.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr))))) {
            return new MenuCombo(x.value0.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 57, column 1 - line 57, column 70): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Pizza) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Dish) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof Drink) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof SplitPizza) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof CustomProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)))));
        };
        if (x instanceof MenuProduct) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))))));
        };
        if (x instanceof MenuCombo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))))));
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 57, column 1 - line 57, column 70): " + [ x.constructor.name ]);
    }
};
var genericStoredPizzaDef = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new StandardPizza(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new CustomPizza(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 117, column 1 - line 117, column 66): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof StandardPizza) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof CustomPizza) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 117, column 1 - line 117, column 66): " + [ x.constructor.name ]);
    }
};
var showStoredPizzaDef = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStoredPizzaDef)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_Types_Id.showPizzaId))({
        reflectSymbol: function () {
            return "StandardPizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "toppings";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_Types_Id.showToppingId)))(Restaumatic_Menu_Types_Id.showPizzaId))))({
        reflectSymbol: function () {
            return "CustomPizza";
        }
    })))
};
var showStoredProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericStoredProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "def";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "size";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showPizzaSize))(Restaumatic_Menu_Types_Id.showPanType))(showStoredPizzaDef))))({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sides";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Cart_ProductKey.showSideDishKey)))(Restaumatic_Menu_Types_Id.showDishId))))({
        reflectSymbol: function () {
            return "Dish";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "size";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showDrinkSize))(Restaumatic_Menu_Types_Id.showDrinkId))))({
        reflectSymbol: function () {
            return "Drink";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "size";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showPizzaSize))(/* #__PURE__ */ Data_Show.showArray(showStoredPizzaDef)))(Restaumatic_Menu_Types_Id.showPanType))))({
        reflectSymbol: function () {
            return "SplitPizza";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Taxes.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartProductKey))({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartComboKey))({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    }))))))))
};
var udecodeStoredPizzaDef = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericStoredPizzaDef)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "StandardPizza";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_Types_Id.udecodePizzaId)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "CustomPizza";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(Restaumatic_Menu_Types_Id.udecodePizzaId)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_Types_Id.udecodeForeignToppingId))(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var udecodeStoredProductKey = {
    unsafeDecode: /* #__PURE__ */ (function () {
        var fixup = function (v) {
            if (v instanceof Dish) {
                return new Dish({
                    id: v.value0.id,
                    sides: Data_Array.sort(Restaumatic_Cart_ProductKey.ordSideDishKey)(v.value0.sides)
                });
            };
            return v;
        };
        var decode$prime = Unscramble_Generic.genericUnsafeDecode(genericStoredProductKey)(Unscramble_Generic.genericDecode(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "Pizza";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr()(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "def";
            }
        })(udecodeStoredPizzaDef)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "panType";
            }
        })(Restaumatic_Menu_Types_Id.udecodePanType)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "size";
            }
        })(Restaumatic_Menu_Types_Id.udecodePizzaSize)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "Dish";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr()(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "id";
            }
        })(Restaumatic_Menu_Types_Id.udecodeDishId)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "sides";
            }
        })(Unscramble.decodeArray1(Restaumatic_Cart_ProductKey.udecodeForeignSideDishKey))(Unscramble.decodeRecordNil)))))(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "Drink";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr()(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "id";
            }
        })(Restaumatic_Menu_Types_Id.udecodeDrinkId)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "size";
            }
        })(Restaumatic_Menu_Types_Id.udecodeDrinkSize)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "SplitPizza";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr()(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "panType";
            }
        })(Restaumatic_Menu_Types_Id.udecodePanType)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "parts";
            }
        })(Unscramble.decodeArray1(udecodeStoredPizzaDef))(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "size";
            }
        })(Restaumatic_Menu_Types_Id.udecodePizzaSize)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "CustomProduct";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr()(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "name";
            }
        })(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "price";
            }
        })(Data_Money_Rounded.udecodeMoney)(Unscramble.decodeRecordCons({
            reflectSymbol: function () {
                return "vatRate";
            }
        })(Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Taxes.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil))))))(Unscramble_Generic.genericDecodeSumSum(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "MenuProduct";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_CartToOrder.unscrambleDecodeCartProductKey)))(Unscramble_Generic.genericDecodeSumConstruct({
            reflectSymbol: function () {
                return "MenuCombo";
            }
        })(Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_CartToOrder.unscrambleDecodeCartComboKey))))))))))(Unscramble_Generic.defaultOptions);
        return function ($101) {
            return fixup(decode$prime($101));
        };
    })()
};
var fromStoredPizzaDef = function (v) {
    if (v instanceof StandardPizza) {
        return new Restaumatic_Cart_ProductKey.StandardPizza(v.value0);
    };
    if (v instanceof CustomPizza) {
        return new Restaumatic_Cart_ProductKey.CustomPizza({
            basePizzaId: v.value0.basePizzaId,
            toppings: Data_MultiSet.fromArray(Restaumatic_Menu_Types_Id.ordToppingId)(v.value0.toppings)
        });
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 175, column 3 - line 177, column 108): " + [ v.constructor.name ]);
};
var fromStoredSplitPizzaKey = function (x) {
    return {
        parts: Data_Functor.map(Data_Functor.functorArray)(fromStoredPizzaDef)(x.parts),
        size: x.size,
        panType: x.panType
    };
};
var fromStoredProductKey = function (v) {
    if (v instanceof Pizza) {
        return new Restaumatic_Cart_ProductKey.Pizza({
            def: fromStoredPizzaDef(v.value0.def),
            size: v.value0.size,
            panType: v.value0.panType
        });
    };
    if (v instanceof Dish) {
        return new Restaumatic_Cart_ProductKey.Dish({
            id: v.value0.id,
            sides: Data_Set.fromFoldable(Data_Foldable.foldableArray)(Restaumatic_Cart_ProductKey.ordSideDishKey)(v.value0.sides)
        });
    };
    if (v instanceof Drink) {
        return new Restaumatic_Cart_ProductKey.Drink(v.value0);
    };
    if (v instanceof SplitPizza) {
        return new Restaumatic_Cart_ProductKey.SplitPizza(fromStoredSplitPizzaKey(v.value0));
    };
    if (v instanceof CustomProduct) {
        return new Restaumatic_Cart_ProductKey.CustomProduct(v.value0);
    };
    if (v instanceof MenuProduct) {
        return new Restaumatic_Cart_ProductKey.MenuProduct(v.value0);
    };
    if (v instanceof MenuCombo) {
        return new Restaumatic_Cart_ProductKey.MenuCombo(v.value0);
    };
    throw new Error("Failed pattern match at Restaumatic.Cart.State.StoredProductKey (line 161, column 3 - line 168, column 38): " + [ v.constructor.name ]);
};
var eqStoredPizzaDef = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericStoredPizzaDef)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Restaumatic_Menu_Types_Id.eqPizzaId)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Menu_Types_Id.eqToppingId)))()({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaId))))))
};
var eqStoredProductKey = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericStoredProductKey)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaSize))()({
        reflectSymbol: function () {
            return "panType";
        }
    })(Restaumatic_Menu_Types_Id.eqPanType))()({
        reflectSymbol: function () {
            return "def";
        }
    })(eqStoredPizzaDef)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Cart_ProductKey.eqSideDishKey)))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDishId)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.eqDrinkSize))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDrinkId)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "size";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaSize))()({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(eqStoredPizzaDef)))()({
        reflectSymbol: function () {
            return "panType";
        }
    })(Restaumatic_Menu_Types_Id.eqPanType)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Taxes.eqVatRate)))()({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.eqMoney))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString)))))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Restaumatic_Menu_V2_Types_CartToOrder.eqCartProductKey)))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(Restaumatic_Menu_V2_Types_CartToOrder.eqCartComboKey)))))))))
};
var encodeStoredPizzaDef = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericStoredPizzaDef)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "StandardPizza";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodePizzaId))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CustomPizza";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_Types_Id.encodeForeignToppingId))))({
        reflectSymbol: function () {
            return "basePizzaId";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodePizzaId)))))))
};
var encodeStoredProductKey = {
    encode: /* #__PURE__ */ Foreign_Generic.genericEncode(genericStoredProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Pizza";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "size";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodePizzaSize)))({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodePanType)))({
        reflectSymbol: function () {
            return "def";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeStoredPizzaDef))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Dish";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Cart_ProductKey.encodeForeignSideDishKey))))({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodeDishId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Drink";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "size";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodeDrinkSize)))({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodeDrinkId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SplitPizza";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "size";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodePizzaSize)))({
        reflectSymbol: function () {
            return "parts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeStoredPizzaDef))))({
        reflectSymbol: function () {
            return "panType";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_Types_Id.encodePanType))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "CustomProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "vatRate";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Taxes.encodeVatRate))))({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "MenuProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.encodeCartProductKey))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "MenuCombo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.encodeCartComboKey))))))))))(Foreign_Generic_Class.defaultOptions)
};
var decodeStoredPizzaDef = {
    decode: function (x) {
        var rename = function (v) {
            if (v === "SStandardPizza") {
                return "StandardPizza";
            };
            if (v === "SCustomPizza") {
                return "CustomPizza";
            };
            return v;
        };
        return Control_Alt.alt(Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity))(Foreign_Generic.genericDecode(genericStoredPizzaDef)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "StandardPizza";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePizzaId)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "CustomPizza";
            }
        })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "toppings";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_Types_Id.decodeForeignToppingId)))())({
            reflectSymbol: function () {
                return "basePizzaId";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePizzaId))())))(Foreign_Generic_Class.genericCountArgsArgument)))(Foreign_Generic_Class.defaultOptions)(renameTags(rename)(x)))(Foreign_Encoding.defaultDecode(genericStoredPizzaDef)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "StandardPizza";
            }
        })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePizzaId)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor({
            reflectSymbol: function () {
                return "CustomPizza";
            }
        })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
            reflectSymbol: function () {
                return "toppings";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_Types_Id.decodeForeignToppingId)))())({
            reflectSymbol: function () {
                return "basePizzaId";
            }
        })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePizzaId))())))(Foreign_Generic_Class.genericCountArgsArgument)))(x));
    }
};
var decodeStoredProductKey = {
    decode: /* #__PURE__ */ (function () {
        var rename = function (v) {
            if (v === "SPizza") {
                return "Pizza";
            };
            if (v === "SDish") {
                return "Dish";
            };
            if (v === "SDrink") {
                return "Drink";
            };
            return v;
        };
        var fixup = function (v) {
            if (v instanceof Dish) {
                return new Dish({
                    id: v.value0.id,
                    sides: Data_Array.sort(Restaumatic_Cart_ProductKey.ordSideDishKey)(v.value0.sides)
                });
            };
            return v;
        };
        var decode$prime = (function () {
            var $102 = Foreign_Generic.genericDecode(genericStoredProductKey)(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "Pizza";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "size";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePizzaSize))())({
                reflectSymbol: function () {
                    return "panType";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePanType))())({
                reflectSymbol: function () {
                    return "def";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(decodeStoredPizzaDef))())))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "Dish";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "sides";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(Restaumatic_Cart_ProductKey.decodeForeignSideDishKey)))())({
                reflectSymbol: function () {
                    return "id";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodeDishId))())))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "Drink";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "size";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodeDrinkSize))())({
                reflectSymbol: function () {
                    return "id";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodeDrinkId))())))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "SplitPizza";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "size";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePizzaSize))())({
                reflectSymbol: function () {
                    return "parts";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.arrayDecode(decodeStoredPizzaDef)))())({
                reflectSymbol: function () {
                    return "panType";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_Types_Id.decodePanType))())))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "CustomProduct";
                }
            })(Foreign_Generic_Class.genericDecodeArgsRecord(Foreign_Generic_Class.decodeWithOptionsRecord()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
                reflectSymbol: function () {
                    return "vatRate";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Taxes.decodeVatRate)))())({
                reflectSymbol: function () {
                    return "price";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())({
                reflectSymbol: function () {
                    return "name";
                }
            })(Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeSum(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "MenuProduct";
                }
            })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.decodeCartProductKey)))(Foreign_Generic_Class.genericCountArgsArgument))(Foreign_Generic_Class.genericDecodeConstructor({
                reflectSymbol: function () {
                    return "MenuCombo";
                }
            })(Foreign_Generic_Class.genericDecodeArgsArgument(Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.decodeCartComboKey)))(Foreign_Generic_Class.genericCountArgsArgument))))))))(Foreign_Generic_Class.defaultOptions);
            var $103 = renameTags(rename);
            return function ($104) {
                return $102($103($104));
            };
        })();
        var $105 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity))(fixup);
        return function ($106) {
            return $105(decode$prime($106));
        };
    })()
};
export {
    Pizza,
    Dish,
    Drink,
    SplitPizza,
    CustomProduct,
    MenuProduct,
    MenuCombo,
    StandardPizza,
    CustomPizza,
    toStoredProductKey,
    toStoredSplitPizzaKey,
    fromStoredProductKey,
    fromStoredSplitPizzaKey,
    genericStoredProductKey,
    showStoredProductKey,
    eqStoredProductKey,
    decodeStoredProductKey,
    udecodeStoredProductKey,
    encodeStoredProductKey,
    genericStoredPizzaDef,
    showStoredPizzaDef,
    eqStoredPizzaDef,
    decodeStoredPizzaDef,
    udecodeStoredPizzaDef,
    encodeStoredPizzaDef
};
//# sourceMappingURL=index.js.map
